/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { CreateEnumerationValueDto } from './CreateEnumerationValueDto';
import {
    CreateEnumerationValueDtoFromJSON,
    CreateEnumerationValueDtoFromJSONTyped,
    CreateEnumerationValueDtoToJSON,
} from './CreateEnumerationValueDto';
import type { CreateNumericValueDto } from './CreateNumericValueDto';
import {
    CreateNumericValueDtoFromJSON,
    CreateNumericValueDtoFromJSONTyped,
    CreateNumericValueDtoToJSON,
} from './CreateNumericValueDto';

/**
 * 
 * @export
 * @interface CreateBeamShapingGroupCircularDto
 */
export interface CreateBeamShapingGroupCircularDto {
    /**
     * 
     * @type {string}
     * @memberof CreateBeamShapingGroupCircularDto
     */
    id: string;
    /**
     * 
     * @type {CreateEnumerationValueDto}
     * @memberof CreateBeamShapingGroupCircularDto
     */
    radiationFieldShape?: CreateEnumerationValueDto;
    /**
     * 
     * @type {CreateEnumerationValueDto}
     * @memberof CreateBeamShapingGroupCircularDto
     */
    radiationFieldSymmetry?: CreateEnumerationValueDto;
    /**
     * 
     * @type {CreateNumericValueDto}
     * @memberof CreateBeamShapingGroupCircularDto
     */
    radiationFieldSize?: CreateNumericValueDto;
    /**
     * 
     * @type {string}
     * @memberof CreateBeamShapingGroupCircularDto
     */
    $type?: CreateBeamShapingGroupCircularDtoTypeEnum;
}


/**
 * @export
 */
export const CreateBeamShapingGroupCircularDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedTaskItemComponentDtoSystemSetupParametersCreateBeamShapingGroupCircularDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.SystemSetupParameters.CreateBeamShapingGroupCircularDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type CreateBeamShapingGroupCircularDtoTypeEnum = typeof CreateBeamShapingGroupCircularDtoTypeEnum[keyof typeof CreateBeamShapingGroupCircularDtoTypeEnum];



/**
 * Check if a given object implements the CreateBeamShapingGroupCircularDto interface.
 */
export function instanceOfCreateBeamShapingGroupCircularDto(value?: unknown): value is CreateBeamShapingGroupCircularDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(CreateBeamShapingGroupCircularDtoTypeEnum)[0];
}

export function CreateBeamShapingGroupCircularDtoFromJSON(json: any): CreateBeamShapingGroupCircularDto {
    return CreateBeamShapingGroupCircularDtoFromJSONTyped(json, false);
}

export function CreateBeamShapingGroupCircularDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateBeamShapingGroupCircularDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'radiationFieldShape': json['radiationFieldShape'] == null ? undefined : CreateEnumerationValueDtoFromJSON(json['radiationFieldShape']),
        'radiationFieldSymmetry': json['radiationFieldSymmetry'] == null ? undefined : CreateEnumerationValueDtoFromJSON(json['radiationFieldSymmetry']),
        'radiationFieldSize': json['radiationFieldSize'] == null ? undefined : CreateNumericValueDtoFromJSON(json['radiationFieldSize']),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function CreateBeamShapingGroupCircularDtoToJSON(value?: CreateBeamShapingGroupCircularDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value['id'],
        'radiationFieldShape': CreateEnumerationValueDtoToJSON(value['radiationFieldShape']),
        'radiationFieldSymmetry': CreateEnumerationValueDtoToJSON(value['radiationFieldSymmetry']),
        'radiationFieldSize': CreateNumericValueDtoToJSON(value['radiationFieldSize']),
        '$type': value['$type'],
    });
}

